import { CardTypes } from '../../api/models/payments';
import masterCardSvg from '../../assets/img/mastercard.svg?react';
import visaSvg from '../../assets/img/visa.svg?react';
import invoiceSvg from '../../assets/img/invoice.svg?react';
import Icon from '@ant-design/icons';
import React from 'react';
import * as PropTypes from 'prop-types';

function PaymentMethodIcon(props) {
  const { cardType, ...rest } = props;
  let component;
  if (cardType) {
    switch (cardType) {
      case CardTypes.MASTERCARD:
        component = masterCardSvg;
        break;
      case CardTypes.VISA:
        component = visaSvg;
        break;
    }
  } else {
    component = invoiceSvg;
  }
  return <Icon component={component} {...rest} />;
}

PaymentMethodIcon.propTypes = {
  cardType: PropTypes.string,
  className: PropTypes.string
};

export default PaymentMethodIcon;
